<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='HIS数据筛选' url='/person/zpgluser/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.realname' label='姓名'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.section' label='科室' :dictid='this.$utils.DictEnum.section'></ZPGLSearchDictItemSelect>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-search" @click="Search(1)">查询</el-button>
          <el-button type="success" icon="el-icon-setting" @click="Updates(2)">住培生</el-button>
          <el-button type="primary" icon="el-icon-setting" @click="Updates(1)">带教老师</el-button>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" ref="multipleTable" :data="tableData" stripe style="width: 100%" size="medium"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="RealName" label="姓名">
            </el-table-column>
            <el-table-column prop="CardNo" label="工号">
            </el-table-column>
            <el-table-column prop="HosName" label="单位">
            </el-table-column>
            <el-table-column prop="SectionName" label="科室">
            </el-table-column>
            <el-table-column label="设置" width="150">
              <template slot-scope="scope">
                <el-button @click="SetUser(scope.row,2)" type="text" size="medium" style="color:green">住培生</el-button>
                <el-button @click="SetUser(scope.row,1)" type="text" size="medium">带教老师</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ZPGLUserList',
    data() {
      return {
        condition: {
          realname: '',
          section: '',
          cardno: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0
        },
        multipleSelection: [],
        multipleSelectionAll: [],
        idKey: 'UserID',
        rolelevel: '',
        tableData: null,
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.changePageCoreRecordData()
        this.condition.currentPage = val
        this.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.changePageCoreRecordData()
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.Search()
      },
      SetUser: function(row, roletype) {
        var message = ""
        if (roletype == 1) {
          message = "确定筛选为带教老师吗！"
        } else {
          message = "确定筛选为住培生吗！"
        }

        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var args = {
            token: this.condition.token,
            id: row.UserID,
            roletype: roletype
          }
          this.$http.post(this.$utils.Url.zpgl + '/api/APIZPGLUser/Update', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '筛选成功',
                  type: 'success'
                })
                console.log('筛选成功')
                this.Search()
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '筛选失败',
                type: 'error'
              })
            })
        }).catch(() => {})
      },
      handleSelectionChange: function(val) {
        this.multipleSelection = val
      },
      Search: function(index) {
        this.loading = true
        if (index != null) {
          this.condition.currentPage = 1
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIZPGLUser/List', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableData = res.data.Data
              this.condition.recordCount = res.data.Pager.RecordCount
              setTimeout(() => {
                this.setSelectRow()
              }, 200)
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tableData = null
            this.condition.recordCount = 0
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      setSelectRow: function() {
        if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
          return
        }
        // 标识当前行的唯一键的名称
        let idKey = this.idKey
        let selectAllIds = []
        this.multipleSelectionAll.forEach(row => {
          selectAllIds.push(row[idKey])
        })
        this.$refs.multipleTable.clearSelection()
        for (var i = 0; i < this.tableData.length; i++) {
          if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
            this.$refs.multipleTable.toggleRowSelection(this.tableData[i], true)
          }
        }
      },
      changePageCoreRecordData: function() {
        // 标识当前行的唯一键的名称
        let idKey = this.idKey
        let that = this
        // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
        if (this.multipleSelectionAll.length <= 0) {
          this.multipleSelectionAll = this.multipleSelection
          return
        }
        // 总选择里面的key集合
        let selectAllIds = []
        this.multipleSelectionAll.forEach(row => {
          selectAllIds.push(row[idKey])
        })
        let selectIds = []
        // 获取当前页选中的id
        this.multipleSelection.forEach(row => {
          selectIds.push(row[idKey])
          // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
          if (selectAllIds.indexOf(row[idKey]) < 0) {
            that.multipleSelectionAll.push(row)
          }
        })
        let noSelectIds = []
        // 得到当前页没有选中的id
        this.tableData.forEach(row => {
          if (selectIds.indexOf(row[idKey]) < 0) {
            noSelectIds.push(row[idKey])
          }
        })
        noSelectIds.forEach(id => {
          if (selectAllIds.indexOf(id) >= 0) {
            for (let i = 0; i < that.multipleSelectionAll.length; i++) {
              if (that.multipleSelectionAll[i][idKey] === id) {
                // 如果总选择中有未被选中的，那么就删除这条
                that.multipleSelectionAll.splice(i, 1)
                break
              }
            }
          }
        })
      },
      Updates: function(roletype) {
        if (this.multipleSelection.length == 0) {
          this.$message({
            message: '没有选择任何数据',
            type: 'error'
          })
          return
        }

        var message = ""
        if (roletype == 1) {
          message = "确定将选中的人员筛选为带教老师吗！"
        } else {
          message = "确定将选中的人员筛选为住培生吗！"
        }

        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var args = {
            token: this.condition.token,
            multipleSelection: this.multipleSelection,
            roletype: roletype
          }
          this.$http.post(this.$utils.Url.zpgl + '/api/APIZPGLUser/Updates', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '筛选成功',
                  type: 'success'
                })
                console.log('筛选成功')
                this.Search()
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '筛选失败',
                type: 'error'
              })
            })
        }).catch(() => {})
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.Search()
    }
  }
</script>

<style scoped="scoped">
  body {
    margin: 0;
  }
</style>
